import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher, Result } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { ContractPopupRepository } from "../domain/ContractPopupRepository";

export class ApiContractPopup implements ContractPopupRepository{
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor(){
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }
    
    async getDistributorUsers(args: object): Promise<any> {
        try{
            const obj = await this.query_dispatcher.dispatch('get.distributor.users', args);
            return obj.data
        }catch(error){
            console.log(error)
            return null
        }
    }

    async getClientUsers(args: object): Promise<any> {
        try{
            const obj = await this.query_dispatcher.dispatch('get.client.users', args);
            return obj.data
        }catch(error){
            console.log(error)
            return null
        }
    }

    async getUserCompanies(args: object): Promise<any> {
        try{
            const result = await this.query_dispatcher.dispatch('get.user.companies', args);
            return result
        }catch(error){
            console.log(error)
            return null
        }
    }

    async getServices(args: object): Promise<any> {
        try{
            const result = await this.query_dispatcher.dispatch('services_prices.fiscal_position', args);
            return result
        }catch(error){
            console.log(error)
            return null
        }
    }

    async payWithTransfer(args: object): Promise<any>{
        try{
            return await this.sync_command_dispatcher.dispatch('buy.services.by.transfer.command', args);
        }catch(error){
            console.log(error)
            return null
        }
    }
    
    async rememberUsedCard(args: object): Promise<any> {
        try{
            return await this.query_dispatcher.dispatch('retrieve.stripe.payment.method', args);
        }catch(error){
            console.log(error)
            return null
        }
    }
    
    async payWithSavedCard(args: object): Promise<any> {
        try{
            return await this.sync_command_dispatcher.dispatch('create.stripe.payment.intent.for.services', args);
        }catch(error){
            console.log(error)
            return null
        }
    }

    async payWithNewCard(args: object): Promise<any> {
        try{
            return await this.sync_command_dispatcher.dispatch('create.stripe.session.for.buy.services', args);
        }catch(error){
            console.log(error)
            return null
        }
    }
}

export class ApiContractPopupMemory implements ContractPopupRepository{
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor(){
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }
    
    async getDistributorUsers(args: object): Promise<any> {
        return [{
            id: 1,
            username: "user.one",
            distributor_code: "D001",
            role: "admin",
        },
        {
            id: 2,
            username: "user.two",
            distributor_code: "D001",
            role: "staff",
        }]
    }

    async getClientUsers(args: object): Promise<any> {
        return [{
            id: 1,
            username: "user.one",
            distributor_code: "D001",
            role: "admin",
        },
        {
            id: 2,
            username: "user.two",
            distributor_code: "D001",
            role: "staff",
        }]
    }

    async getUserCompanies(args: object): Promise<any> {
        return;
    }

    async getServices(args): Promise<any> {
        const res = {}
        for (const service of args.kinds){
            if (args.promotional_code && args.promotional_code == "pc_sergi22"){
                res[service] = discounted_services[service]
            }else {
                res[service] = default_services[service]
            }
        }
        return res
    }

    async payWithTransfer(args: object): Promise<any>{
        if (
            (typeof args["payment_file_path"] == "string" && args["payment_file_path"] == "path/OK")
            && args["service_ids"] instanceof Array
            && (typeof args["num_credits_custom"] == "number" || args["num_credits_custom"] == null)
            && (typeof args["promotional_code"] == "string" || args["promotional_code"] == null)
            && (typeof args["user_id_to_delivery"] == "number" || args["user_id_to_delivery"] == null)
            && (typeof args["company_id_to_facturae"] == "number" || args["company_id_to_facturae"] == null)
            && (typeof args["extra_users"] == "object" || args["extra_users"] == null)
        ){
            return {
                output: {
                    success: true
                }
            }
        }else if(args["payment_file_path"] && args["payment_file_path"] == "path/Esperate 30 min anda"){
            return {
                output: {
                    message: "Esperate 30 min anda"
                }
            }
        }
        return {
            output: {
                message: "Error..."
            }
        }
    }
    
    async rememberUsedCard(args: object): Promise<any> {
        return {
            card_data: {
                stripe_customer_id: "CUS_1",
                payment_method_id: "PM_1",
                last4: "7777",
                use_old_card: true,
            }
        }
    }
    
    async payWithSavedCard(args: object): Promise<any> {
        if (
            args["services"] instanceof Array
            && typeof args["stripe_customer_id"] == "string"
            && typeof args["payment_method_id"] == "string"
            && (typeof args["user_id_to_delivery"] == "number" || args["user_id_to_delivery"] == null)
            && (typeof args["num_credits_custom"] == "number" || args["num_credits_custom"] == null)
            && (typeof args["promotional_code"] == "string" || args["promotional_code"] == null)
            && args["promotional_code"] == "OK"
            && (typeof args["company_id_to_facturae"] == "number" || args["company_id_to_facturae"] == null)
        ){
            return {
                output: {
                    status: "ok"
                }
            }
        }else if(args["promotional_code"] && args["promotional_code"] == "finished_time"){
            return {
                output: {
                    status: "finished_time"
                }
            }
        }
        return {
            output: {
                status: "Error..."
            }
        }
    }

    async payWithNewCard(args: object): Promise<any> {
        if (
            args["service_ids"] instanceof Array && args["service_ids"].length > 0
            && (typeof args["stripe_customer_id"] == "string" || args["stripe_customer_id"] == null)
            && (typeof args["promotional_code"] == "string" || args["promotional_code"] == null)
            && args["promotional_code"] == "OK"
            && (typeof args["user_id_to_deliver"] == "number" || args["user_id_to_deliver"] == null)
            && (typeof args["num_credits_custom"] == "number" || args["num_credits_custom"] == null)
            && (typeof args["company_id_to_facturae"] == "number" || args["company_id_to_facturae"] == null)
        ){
            return {
                output: {
                    url: "https://fakeaso_de_manual"
                }
            }
        }
        return {
            output: {
                url: "Error..."
            }
        }
    }
}

export let default_services = {
    "documents": [
        {
            "service_id": 1,
            "name": "Basic",
            "product_code": "INM5K",
            "price": 449,
            "yearly_documents": 5000,
            "old_price": 318,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 5000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 543,29 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 2,
            "name": "Pro",
            "product_code": "INMK20",
            "price": 1499,
            "yearly_documents": 20000,
            "old_price": 1200,
            "trial_customer_promotion_code": null,
            "limit_users": 5,
            "yearly": 20000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 1.813,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 3,
            "name": "Premium",
            "product_code": "INMK40",
            "price": 2499,
            "yearly_documents": 40000,
            "old_price": 2004,
            "trial_customer_promotion_code": null,
            "limit_users": 10,
            "yearly": 40000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 3.023,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 4,
            "name": "Enterprise",
            "product_code": "INM90K",
            "price": 5499,
            "yearly_documents": 100000,
            "old_price": 4500,
            "trial_customer_promotion_code": null,
            "limit_users": 1000,
            "yearly": 100000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 6.653,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ],
    "banks": [
        {
            "service_id": 8,
            "name": "Basic",
            "product_code": "INM5KB",
            "price": 399,
            "yearly_transactions": 5000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 1,
            "yearly": 5000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 482,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 9,
            "name": "Pro",
            "product_code": "INM20KB",
            "price": 1199,
            "yearly_transactions": 20000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 5,
            "yearly": 20000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 1.450,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 10,
            "name": "Premium",
            "product_code": "INM40KB",
            "price": 1899,
            "yearly_transactions": 40000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 10,
            "yearly": 40000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 2.297,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 11,
            "name": "Enterprise",
            "product_code": "INM100KB",
            "price": 3999,
            "yearly_transactions": 100000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 1000,
            "yearly": 100000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 4.838,79 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ],
    "credits": [
        {
            "service_id": 45,
            "name": "Basic",
            "product_code": "INM5KC",
            "price": 500,
            "total_credits": 5000,
            "trial_credits": 100,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 5000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 605,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 46,
            "name": "Pro",
            "product_code": "INM10KC",
            "price": 1000,
            "total_credits": 10000,
            "trial_credits": 200,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 10000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 1.210,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 47,
            "name": "Premium",
            "product_code": "INM20KC",
            "price": 2000,
            "total_credits": 20000,
            "trial_credits": 400,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 20000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 2.420,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 48,
            "name": "Enterprise",
            "product_code": "INM50KC",
            "price": 5000,
            "total_credits": 50000,
            "trial_credits": 1000,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 50000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 6.050,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ],
    "facturae_credits": [
        {
            "service_id": 49,
            "name": "Basic",
            "product_code": "INM20FE",
            "price": 60,
            "total_credits": 1,
            "trial_credits": 1,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": "",
            "yearly_text": "x empresa/año",
            "extra_users_price": null,
            "old_price": null,
            "is_valid_code": false,
            "total_with_taxes": "Total con IVA (21%): 72,60 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ]
}

// 30% de descuento sergi22
let discounted_services = {
    "documents": [
        {
            "service_id": 1,
            "name": "Basic",
            "product_code": "INM5K",
            "price": 359.2,
            "yearly_documents": 5000,
            "old_price": 318,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 5000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 434,63 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 2,
            "name": "Pro",
            "product_code": "INMK20",
            "price": 1199.2,
            "yearly_documents": 20000,
            "old_price": 1200,
            "trial_customer_promotion_code": null,
            "limit_users": 5,
            "yearly": 20000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 1.451,03 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 3,
            "name": "Premium",
            "product_code": "INMK40",
            "price": 1999.2,
            "yearly_documents": 40000,
            "old_price": 2004,
            "trial_customer_promotion_code": null,
            "limit_users": 10,
            "yearly": 40000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 2.419,03 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 4,
            "name": "Enterprise",
            "product_code": "INM90K",
            "price": 4399.2,
            "yearly_documents": 100000,
            "old_price": 4500,
            "trial_customer_promotion_code": null,
            "limit_users": 1000,
            "yearly": 100000,
            "yearly_text": "documentos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 5.323,03 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ],
    "banks": [
        {
            "service_id": 8,
            "name": "Basic",
            "product_code": "INM5KB",
            "price": 319.2,
            "yearly_transactions": 5000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 1,
            "yearly": 5000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 386,23 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 9,
            "name": "Pro",
            "product_code": "INM20KB",
            "price": 959.2,
            "yearly_transactions": 20000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 5,
            "yearly": 20000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 1.160,63 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 10,
            "name": "Premium",
            "product_code": "INM40KB",
            "price": 1519.2,
            "yearly_transactions": 40000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 10,
            "yearly": 40000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 1.838,23 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 11,
            "name": "Enterprise",
            "product_code": "INM100KB",
            "price": 3199.2,
            "yearly_transactions": 100000,
            "trial_transactions": 100,
            "trial_customer_promotion_code": null,
            "limit_users": 1000,
            "yearly": 100000,
            "yearly_text": "movimientos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 3.871,03 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ],
    "credits": [
        {
            "service_id": 45,
            "name": "Basic",
            "product_code": "INM5KC",
            "price": 400,
            "total_credits": 5000,
            "trial_credits": 100,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 5000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 484,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 46,
            "name": "Pro",
            "product_code": "INM10KC",
            "price": 800,
            "total_credits": 10000,
            "trial_credits": 200,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 10000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 968,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 47,
            "name": "Premium",
            "product_code": "INM20KC",
            "price": 1600,
            "total_credits": 20000,
            "trial_credits": 400,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 20000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 1.936,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        },
        {
            "service_id": 48,
            "name": "Enterprise",
            "product_code": "INM50KC",
            "price": 4000,
            "total_credits": 50000,
            "trial_credits": 1000,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": 50000,
            "yearly_text": "créditos/año",
            "extra_users_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 4.840,00 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ],
    "facturae_credits": [
        {
            "service_id": 49,
            "name": "Basic",
            "product_code": "INM20FE",
            "price": 48,
            "total_credits": 1,
            "trial_credits": 1,
            "trial_customer_promotion_code": null,
            "limit_users": null,
            "yearly": "",
            "yearly_text": "x empresa/año",
            "extra_users_price": null,
            "old_price": null,
            "is_valid_code": true,
            "total_with_taxes": "Total con IVA (21%): 58,08 €",
            "tax_rate": 0.21,
            "tax_name": "IVA"
        }
    ]
}